<script lang="ts">
  import {
    scrollDisabled,
    scrollBarWidth,
    activeSection,
    menu,
    colors,
    activeColor,
  } from "$lib/data";
  import { page } from "$app/stores";
  import SocialNetworks from "$lib/components/layout/footer/SocialNetworks.svelte";

  let browserWidth: number;
</script>

<svelte:window bind:innerWidth={browserWidth} />
<footer
  style:padding-right="{$scrollDisabled ? $scrollBarWidth : 0}px"
  style:padding-bottom="{$activeSection === 'episodes' && browserWidth <= 1024
    ? 5
    : 0}rem"
  style="
        --primary: {colors[$activeColor].color};
        --secondary: {colors[$activeColor].highlight};
    "
>
  <div id="footerBar" />
  <div class="column top">
    <div class="email_box">
      {#if !$page.data.user?.id}
        <a href="/login">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"
            ><rect width="256" height="256" fill="none" /><rect
              x="40"
              y="88"
              width="176"
              height="128"
              rx="8"
              fill="none"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="16"
            /><path
              d="M88,88V56a40,40,0,0,1,40-40c19.35,0,36.29,13.74,40,32"
              fill="none"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="16"
            /></svg
          >
          Member Login
        </a>
      {/if}
      <a href="/email">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"
          ><rect width="256" height="256" fill="none" /><path
            d="M223.69,42.18a8,8,0,0,0-9.87-9.87l-192,58.22a8,8,0,0,0-1.25,14.93L106.19,146a8,8,0,0,1,3.8,3.8l40.55,85.61a8,8,0,0,0,14.93-1.25Z"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="16"
          /><line
            x1="108.42"
            y1="147.58"
            x2="160"
            y2="96"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="16"
          /></svg
        >
        Signup for our Email List
      </a>
    </div>
    <SocialNetworks />
  </div>
  <nav class="footerLinks" aria-label="Main navigation menu">
    <div class="column">
      {#each menu as item, index}
        <div class="col">
          <a
            class="sectionHead"
            href={menu[index].sub[0].href}
            class:active={$activeSection === item.section}
            tabindex="0"
          >
            {#if item.loggedInText && $page.data.user?.id}
              {item.loggedInText}
            {:else}
              {item.text}
            {/if}
          </a>
          <ul>
            {#each menu[index].sub as item}
              <li class:active={$page.url.pathname === item.href}>
                <a
                  href={item.loggedInHref && $page.data.user?.id
                    ? item.loggedInHref
                    : item.href}
                  rel={item.external ? "external" : ""}
                >
                  {#if item.loggedInText && $page.data.user?.id}
                    {item.loggedInText}
                  {:else}
                    {item.text}
                  {/if}
                </a>
                {#if (item.sub ?? []).length > 0}
                  <ul>
                    {#each item.sub ?? [] as sub}
                      <li>
                        <a
                          href={sub.loggedInHref && $page.data.user?.id
                            ? sub.loggedInHref
                            : sub.href}
                          rel={sub.external ? "external" : ""}
                        >
                          {#if sub.loggedInText && $page.data.user?.id}
                            {sub.loggedInText}
                          {:else}
                            {sub.text}
                          {/if}
                        </a>
                      </li>
                    {/each}
                  </ul>
                {/if}
              </li>
            {/each}
          </ul>
        </div>
      {/each}
    </div>
  </nav>
  <div class="copyright">
    <div class="column">
      <small>
        &copy; Copyright {new Date().getFullYear()} FUNN Company LLC. All rights
        reserved.
      </small>
      <small>
        <a href="/privacy-policy">Privacy Policy</a>
        <a href="/terms-and-conditions">Terms & Conditions</a>
        <a href="/angel-policy">Angel Policy</a>
      </small>
    </div>
  </div>
</footer>

<style>
  footer {
    background-color: #242f36;
    background-image: linear-gradient(315deg, #41424a 0%, #242f36 74%);
    padding-top: 0;
    position: sticky;
    top: 100vh;
  }
  footer .email_box {
    min-height: 6rem;
    border-radius: 2rem;
    color: white;
    display: flex;
    align-items: center;
    gap: 1rem;
    justify-content: space-around;
    position: relative;
  }
  footer .email_box a {
    padding: 1.1rem 1.75rem 1rem 1.75rem;
    color: white;
    border-radius: 1rem;
    font-size: 1.1rem;
    cursor: pointer;
    font-weight: bold;
    box-shadow: 3px 3px rgba(0, 0, 0, 0.1);
    background-color: var(--secondary);
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 1rem;
  }
  footer .email_box a svg {
    width: 1.5rem;
    height: 1.5rem;
  }
  footer .email_box a:hover,
  footer .email_box a:focus {
    background: var(--primary);
  }
  @media (max-width: 800px) {
    footer .email_box {
      flex-flow: column;
      align-items: stretch;
      text-align: center;
    }
  }
  footer #footerBar {
    background-color: #4c4177;
    background-image: linear-gradient(315deg, #4c4177 0%, #2a5470 74%);
    height: 8px;
  }
  footer .footerLinks {
    border-top: 1px solid rgba(0, 0, 0, 0.2);
    margin-top: 1rem;
    position: relative;
  }
  footer .footerLinks > div {
    display: flex;
    gap: 2rem;
    flex-wrap: wrap;
    justify-content: space-around;
    padding-top: 2rem;
    padding-bottom: 1rem;
    position: relative;
  }
  footer .footerLinks > div > div {
    flex: 1 1 auto;
  }
  footer .footerLinks > div > div ul {
    margin: 0.5rem 0 0 0;
  }
  footer .footerLinks > div > div ul li::marker {
    color: var(--secondary);
  }
  footer .footerLinks > div > div ul li {
    padding: 0.25rem;
  }
  footer .footerLinks > div > div ul li a:hover {
    color: var(--secondary);
  }
  footer .footerLinks > div > div ul li ul {
    list-style-type: square;
    margin-left: -1.1rem;
    margin-bottom: 0.75rem;
  }
  footer .footerLinks > div > div ul li ul li {
    padding: 0.15rem;
  }
  footer .footerLinks > div > div ul li ul li a {
    font-size: 0.85rem;
  }
  @media (max-width: 600px) {
    footer .footerLinks > div > div ul li ul {
      margin-left: 2rem;
    }
  }
  @media (max-width: 600px) {
    footer .footerLinks > div > div ul {
      margin-left: 1.5rem;
    }
  }
  footer .footerLinks > div > div a.sectionHead {
    font-family: "Bitter", serif;
    font-weight: bold;
    font-size: 1.3rem;
    color: var(--primary);
  }
  footer .footerLinks a {
    color: white;
    font-size: 1rem;
    font-weight: normal;
    text-decoration: none;
  }
  footer .top {
    margin-top: 2rem;
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    gap: 2rem;
    padding-bottom: 2rem;
    align-items: center;
  }
  @media (max-width: 800px) {
    footer .top {
      flex-flow: column;
      justify-content: center;
    }
  }
  footer .copyright {
    border-top: 1px solid rgba(0, 0, 0, 0.2);
    margin-top: 1rem;
    color: white;
    padding: 1.5rem 0;
    font-size: 1.1rem;
    font-weight: bold;
  }
  footer .copyright .column {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  footer .copyright .column small:first-of-type {
    margin-right: 1.5rem;
  }
  footer .copyright .column a {
    color: white;
    margin-right: 1rem;
  }
  footer .copyright .column a:hover {
    color: var(--light);
  }
  footer .copyright .column a:last-of-type {
    margin-right: 0;
  }

  @media (max-width: 600px) {
    .copyright {
      padding: 0;
    }
    .copyright .column {
      display: flex;
      flex-flow: column;
      justify-content: center;
      text-align: center;
      padding: 0 1rem;
    }
    .copyright .column small {
      padding: 0;
      display: flex;
      gap: 0.7rem;
      flex-flow: column;
      justify-content: center;
      text-align: center;
      margin: 1rem 0 !important;
      text-wrap: balance;
      line-height: 1.6;
    }
    .copyright .column small a {
      margin: 0;
      padding: 0;
    }
    .footerLinks > div {
      flex-flow: column;
    }
    .footerLinks > div > div {
      margin: 0 2rem;
      padding: 0 2rem;
    }
    .footerLinks > div > div ul {
      padding: 0;
    }
    .footerLinks > div > div ul li {
      padding: 0;
    }
    .footerLinks ul li a {
      padding: 0.25rem 0;
      display: flex;
    }
  }
</style>
